<app-pesquisa [(showDialog)]="pesquisarDialog" (pessoa)="loadData($event)"></app-pesquisa>

<app-relatorio-container
    tituloRelatorio="Declaração de Inscrição"
    descricaoRelatorio="Declaração de inscrição e habilitação do médico."
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'certidao-inscricao-medico.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6">
            <p class="text-sm text-muted-color">A declaração será emitida para o médico selecionado, atestando que encontra-se inscrito(a) e habilitado(a) a exercer a medicina neste Estado. Não permitida para médicos com situação Cancelado.</p>

            <app-card-medico-selecionado [pessoa]="pessoa()" [pessoaResponse]="pessoaResponse()" (alterar)="showPesquisarPessoa()"></app-card-medico-selecionado>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button
                    label="Gerar Declaração"
                    icon="pi pi-file-pdf"
                    [appCan]="roleGerar"
                    (click)="gerarRelatorio()"
                    [loading]="isPending"
                    [disabled]="isPending || !possuiPessoaSelecionada"
                    pTooltip="Para gerar o relatório, selecione um médico."
                    tooltipPosition="top"
                    [tooltipDisabled]="possuiPessoaSelecionada"
                ></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
